import { useMemo } from 'react'

const useStyle = () => useMemo(
  () => ({
    wrapperBorder: { size: '1px', color: '#669944' },
    wrapperPad: { horizontal: '6px', vertical: '8px' },
    wrapperFxMargin: {
      large: { vertical: 'medium' },
      other: { bottom: 'medium' },
    },
    containerPosition: { position: 'relative' },
    iconWrapperMinWidth: { minWidth: 34 },
    textWrapperPad: { left: 'small' },
    textFxSize: { large: '16px', other: '14px' },
    linkMarginTop: { top: 'small' },
    linkFxSize: { large: '14px', other: '12px' },
    linkCursor: {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  }),
  [],
)

export default useStyle
